import { glyphPaths } from '../icons/icon-paths';

// Function to add glyphs to elements with glyphed-text class
export function addGlyphsToText() {
  // Get all elements with the glyphed-text class
  const glyphedElements = document.querySelectorAll('.glyphed-text');
  
  glyphedElements.forEach((element, index) => {
    // Skip if already processed
    if (element.dataset.glyphsAdded === 'true') {
      return;
    }
    
    // Mark as processed
    element.dataset.glyphsAdded = 'true';
    
    // Ensure the element has relative positioning for absolute glyphs
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.position === 'static') {
      element.style.position = 'relative';
    }
    
    // Create top-left glyph
    const topLeftGlyph = document.createElement('div');
    topLeftGlyph.className = 'glyph-decorator top-left';
    topLeftGlyph.style.cssText = `
      position: absolute;
      top: 0.15em;
      left: -0.15em;
      width: 16px;
      height: 16px;
      z-index: 10;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, -50%);
    `;
    
    // Add SVG content to glyph
    const glyphKeys = Object.keys(glyphPaths);
    const topLeftGlyphKey = glyphKeys[index % glyphKeys.length];
    
    topLeftGlyph.innerHTML = `
      <svg viewBox="0 0 24 24" width="16" height="16" fill="var(--c4, #3520D6)">
        ${glyphPaths[topLeftGlyphKey]}
      </svg>
    `;
    
    // Append glyph to the element
    element.appendChild(topLeftGlyph);
  });
}

// Function to remove glyphs (for cleanup)
export function removeGlyphsFromText() {
  const glyphedElements = document.querySelectorAll('.glyphed-text');
  
  glyphedElements.forEach((element) => {
    // Remove glyph elements
    const glyphs = element.querySelectorAll('.glyph-decorator');
    glyphs.forEach(glyph => glyph.remove());
    
    // Remove the processed flag
    delete element.dataset.glyphsAdded;
  });
}

// Auto-initialize when DOM is ready
if (typeof window !== 'undefined') {
  // Run on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addGlyphsToText);
  } else {
    // DOM is already loaded
    addGlyphsToText();
  }
  
  // Also run when new content is added (for React apps)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Check if any new nodes have the glyphed-text class
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('glyphed-text')) {
              addGlyphsToText();
            } else if (node.querySelectorAll) {
              const glyphedElements = node.querySelectorAll('.glyphed-text');
              if (glyphedElements.length > 0) {
                addGlyphsToText();
              }
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
} 